import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-popup-menu-item'
})
class EdPopupMenuItemComponent extends Vue {

  @Prop() cssClass: string;

}

export default Vue.component('ed-popup-menu-item', EdPopupMenuItemComponent);